import React, { useState } from "react";
import { ModalTypes, ModalService } from "../../service/modal-service";
import { DeveloperModal } from "../../modals";

const showDevModal = () => {
  ModalService.showModal(ModalTypes.CUSTOM, {
    width: "40%",
    height: "80%",
    content: <DeveloperModal />,
  });
};

export { showDevModal };
